/* loaded by smart-asset */
export default require("./assets/drop-zone-black-pallet.i.svg")